<template>
    <v-layout align-center justify-center style="width: 100%; height :100%;" column>
        <label class="accent--text display-4">404</label>
        <label class="display-3 font-weight-regular text-center">Страница не найдена</label>

        <label class="headline font-weight-light text-center"
               style="margin-top: 20px;" :style="{'max-width': isMobile ? '90%' : '60%' }">
            Извините, указанная страница не найдена. Вернитесь на главную страницу или свяжитесь с администратором.</label>
        <v-btn color="secondary"
               light
               large
               @click="$router.history.push({name: 'home'})"
               style="margin-top: 30px;">На главную</v-btn>
    </v-layout>
</template>

<script>
    export default {
        name: "NotFoundView",
        computed: {
            isMobile() {
                return this.$store.state.isMobile
            }
        }
    }
</script>

<style scoped>

</style>